import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as en from './en';

declare module 'i18next' {
    interface CustomTypeOptions {
        returnNull: false;
    }
}

i18n.use(initReactI18next).init({
    resources: { en },
    lng: 'en',
    returnNull: false,
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    returnObjects: false,
    returnedObjectHandler: (key, value, options) => options.defaultValue,
});

export default i18n;
